export default class TyreBusinessLogic {
  constructor(workPage, stateManager, apiClient, renderer) {
    this.workPage = workPage;
    this.stateManager = stateManager;
    this.apiClient = apiClient;
    this.renderer = renderer;
  }

  addTyre(supplier_code, position, selections) {
    const tyre = this.stateManager.getTyreBySupplierCode(supplier_code);
    let tyre_data = {
      tyre: {
        supplier_code: supplier_code,
        data: tyre,
      },
    };

    if (position === 'both') {
      tyre_data.front = { quantity: selections.quantity('front') };
      tyre_data.rear = { quantity: selections.quantity('rear') };
    } else {
      tyre_data.quantity = selections.quantity(position);
    }

    if (selections.hasSelectedTyres()) {
      this.apiClient.fetchTyresQuote(tyre_data, position);
    } else {
      this.workPage.addJob(5000, 'Tyre fitting', 'tyres');
      this.apiClient.fetchTyresQuote(tyre_data, position);
    }

    selections.tyre(position, tyre);
  }

  removeTyre(position) {
    const selections = this.stateManager.getSelections();
    selections.removeTyre(position);

    if (!selections.hasSelectedTyres()) {
      this.workPage.removeJob(5000, false);
      this.apiClient.deleteTyres(position);
    } else {
      this.apiClient.deleteTyres(position);
    }
  }

  refineAndRenderTyres(tyres, metaData) {
    this.stateManager.setTyres(tyres);
    const refinements = this.stateManager.createRefinements(tyres);
    const filteredTyres = refinements.applyAll();
    this.renderer.renderTyreSelect(
      $('.tyres-page'),
      filteredTyres,
      this.unmatchedSpecifications(this.stateManager.getSelections(), metaData)
    );
    this.renderer.renderTyresBasket($('.tyres-page').find('.tyres-basket'), tyres);
    $('.tyres-active-count').text(filteredTyres.length);
    $('.tyres-total-count').text(tyres.length);
    this.stateManager.setRefinements(refinements);
  }

  applyRefinements() {
    const tyreCards = $('.tyres-page').find('.js-tyres-tyre-cards');

    this.renderer.withSpinner($('.tyres-refine-container'), () => {
      const tyres = this.stateManager.getRefinements().applyAll();
      this.renderer.renderTyreCards(tyreCards, tyres);
      $('.tyres-active-count').text(tyres.length);
    });
    this.renderer.scrollToTarget(tyreCards, -125);
  }

  unmatchedSpecifications(selections, metaData) {
    return Object.keys(metaData).reduce((specs, positionKey) => {
      const position = positionKey === 'both' ? 'front' : positionKey;
      if (metaData[positionKey].count === 0) specs.push(selections.specification(position));
      return specs;
    }, []);
  }
}
